const defaultDestinationSettings = {
  ui: {
    header: 'Sed consequat leo eget',
    description:
      'Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna.',
    icon: {
      id: '1aadcf73-8b14-4b6e-a748-553acfc5a139',
      url: 'https://ldev.pro/images/logo-example.png',
      mimeType: 'image/jpg',
      thmb: [
        {
          id: '1424c2bc-f8c1-40e5-af69-61dfd28f67cb',
          type: 'S_ORIGINAL_ASPECT_RATIO',
          url: 'https://ldev.pro/images/logo-example.png',
          mimeType: 'image/jpg',
        },
        {
          id: 'aa31b08e-44dd-4beb-981a-76c988c3dd87',
          type: 'S',
          url: 'https://ldev.pro/images/logo-example.png',
          mimeType: 'image/jpg',
        },
        {
          id: '08c482e5-1baf-4e75-8f1f-faa1136f8847',
          type: 'XS',
          url: 'https://ldev.pro/images/logo-example.png',
          mimeType: 'image/jpg',
        },
      ],
      fileName: 'pexels-alex-dos-santos-305643819-33256298.jpg',
      rawFileSize: 873001,
      rawFile: 'https://ldev.pro/images/logo-example.png',
      aspectRatio: 1.5,
    },
  },
  links: [
    {
      type: 'whatsapp',
      url: 'https://wa.me',
    },
    {
      type: 'google',
      url: 'https://search.google.com',
    },
    {
      type: 'facebook',
      url: 'https://www.facebook.com',
    },
    {
      type: 'yelp',
      url: 'https://www.yelp.com',
    },
    {
      type: 'trustpilot',
      url: 'https://www.trustpilot.com/',
    },

    {
      type: 'tiktok',
      url: 'https://www.tiktok.com',
    },
    {
      type: 'youtube',
      url: 'https://www.youtube.com',
    },
    {
      type: 'linkedin',
      url: 'https://www.linkedin.com/',
    },
    {
      type: 'pinterest',
      url: 'https://www.pinterest.com/',
    },
    {
      type: 'instagram',
      url: 'https://www.instagram.com/',
    },
    {
      type: 'appointment',
      url: 'https://site.com',
    },
    {
      type: 'website',
      url: 'https://site.com',
    },
    {
      type: 'tripadvisor',
      url: 'https://www.tripadvisor.com/',
    },
  ],
};

export default defaultDestinationSettings;
